const variants = {
  primary: 'bg-accent text-white hover:bg-accent-hover',
  secondary: 'bg-surface-card text-ink border border-border-strong hover:bg-surface-sunken',
  ghost: 'text-ink-muted bg-transparent hover:bg-surface-sunken hover:text-ink',
  // Outlined, never filled — a solid accent-coloured button on screen
  // must only ever mean the primary action.
  danger: 'bg-surface-card text-danger border border-danger-border hover:bg-danger-tint',
};

export default function Button({
  children, variant = 'primary', size = 'md',
  icon: Icon, iconPosition = 'left', className = '',
  disabled, loading, ...props
}) {
  const sizeClass = size === 'sm'
    ? 'h-11 px-3 text-small'
    : 'min-h-touch px-4 text-body';

  return (
    <button
      className={`
        inline-flex items-center justify-center gap-2 rounded-control
        font-display font-semibold transition-colors duration-state
        focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]} ${sizeClass} ${className}
      `}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
      )}
      {Icon && iconPosition === 'left' && !loading && <Icon size={18} strokeWidth={1.5} />}
      {children}
      {Icon && iconPosition === 'right' && <Icon size={18} strokeWidth={1.5} />}
    </button>
  );
}
